import { getField, updateField } from 'vuex-map-fields'
import getCommissionReportFilter from './models/commissionReportFilters'

const commissionReportFilters = {
  namespaced: true,
  state: {
    ...getCommissionReportFilter()
  },
  getters: {
    getField,
    getSearchObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    clearFilters: (state) => {
      state.businessEntityId = null
      state.userId = null
      state.year = new Date().getFullYear()
      state.month = new Date().getMonth() + 1
      state.useNewApproach = false
    }
  },
  actions: {
    clearFilters: ({ commit }) => {
      return commit('clearFilters')
    }
  }
}

export default commissionReportFilters
